import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { FALLBACK_PHOTO, absoluteUrl } from "../lib/api";

export const AthleteCard = ({ athlete, index = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 18 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.45, delay: index * 0.05 }}
  >
    <Link
      to={`/athletes/${athlete.slug}`}
      data-testid={`athlete-card-${athlete.slug}`}
      className="group block bg-[#111111] border border-white/10 hover:border-[#FF5A00] transition-colors"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[#061224]">
        <img
          src={absoluteUrl(athlete.photo_url || FALLBACK_PHOTO)}
          alt={athlete.name}
          className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent" />
        {athlete.featured && (
          <span className="absolute top-3 left-3 bg-[#FF5A00] text-[10px] font-bold tracking-[0.2em] uppercase px-2 py-1">
            Featured
          </span>
        )}
        {!athlete.published && (
          <span className="absolute top-3 right-3 bg-black/80 border border-white/20 text-[10px] font-bold tracking-[0.2em] uppercase px-2 py-1">
            Draft
          </span>
        )}
        {athlete.jersey && (
          <span
            data-testid={`card-jersey-${athlete.slug}`}
            className="absolute top-3 right-3 bg-[#061224]/90 border border-[#FF5A00] text-[#FF5A00] font-display text-2xl leading-none px-2.5 py-1"
          >
            #{String(athlete.jersey).replace("#", "")}
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <p className="label-mono text-[#FF5A00]">{athlete.position || athlete.sport}</p>
          <h3 className="font-display text-xl sm:text-2xl leading-none mt-1">{athlete.name}</h3>
        </div>
      </div>
      <div className="flex items-stretch divide-x divide-white/10 border-t border-white/10">
        {[
          ["HT", athlete.height],
          ["WT", athlete.weight],
          ["TEAM", athlete.team],
        ].map(([label, val]) => (
          <div key={label} className="flex-1 px-2 py-2 min-w-0">
            <p className="label-mono">{label}</p>
            <p className="font-display text-sm truncate">{val || "—"}</p>
          </div>
        ))}
        <div className="flex items-center px-2 text-[#FF5A00] group-hover:translate-x-1 transition-transform">
          <ArrowUpRight size={16} />
        </div>
      </div>
    </Link>
  </motion.div>
);
